import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

import type { GetPendingApplicationsResponse } from "../types";

export const PENDING_APPLICATIONS_QUERY_KEY = ["pending-applications"];

export function useGetPendingApplications(
  enabled: boolean = true,
): UseQueryResult<GetPendingApplicationsResponse> {
  return useQuery<GetPendingApplicationsResponse>({
    enabled,
    queryFn: async () =>
      await apiClient.url("/kickstarter/admin/applications").get().json(),
    queryKey: PENDING_APPLICATIONS_QUERY_KEY,
    refetchOnWindowFocus: false,
    staleTime: 30_000,
  });
}
